(function () {
  'use strict';

  var initialized = false;
  var variants = null;
  var pendingAvailable = null;
  var applyingState = false;

  // Kbite adds data-kbite-initialized asynchronously after insertion, so match without it
  function getKbiteBtn() {
    return document.querySelector('button.gw-button-widget-v2');
  }

  function showKbite() {
    pendingAvailable = true;
    // Body class makes the button visible the instant Kbite inserts it (CSS at paint time)
    document.body.classList.add('kbite-oos');
    var btn = getKbiteBtn();
    if (btn) {
      applyingState = true;
      btn.style.setProperty('display', 'block', 'important');
      applyingState = false;
    }
  }

  function hideKbite() {
    pendingAvailable = false;
    document.body.classList.remove('kbite-oos');
    var btn = getKbiteBtn();
    if (btn) {
      applyingState = true;
      btn.style.setProperty('display', 'none', 'important');
      applyingState = false;
    }
  }

  function applyPending() {
    if (pendingAvailable === null) return;
    pendingAvailable ? showKbite() : hideKbite();
  }

  // Re-apply our state if Kbite overrides the button's inline style after injection
  function observeButtonStyle(btn) {
    var styleObserver = new MutationObserver(function () {
      if (applyingState) return;
      applyPending();
    });
    styleObserver.observe(btn, { attributes: true, attributeFilter: ['style'] });
  }

  function syncFromPageData() {
    var el = document.querySelector('[data-selected-variant]');
    if (!el) return false;
    try {
      var v = JSON.parse(el.textContent);
      v.available ? hideKbite() : showKbite();
      return true;
    } catch (_) {}
    return false;
  }

  function getSelectedOptions() {
    var opts = [];
    var picker = document.querySelector('.variant-selects');
    if (!picker) return opts;

    picker.querySelectorAll('fieldset[data-option-index]').forEach(function (f) {
      var idx = parseInt(f.dataset.optionIndex, 10);
      var checked = f.querySelector('input.input-radio:checked');
      if (checked) opts[idx] = checked.value;
    });

    picker.querySelectorAll('[data-option-index] select').forEach(function (sel) {
      var parent = sel.closest('[data-option-index]');
      if (parent && sel.value) {
        opts[parseInt(parent.dataset.optionIndex, 10)] = sel.value;
      }
    });

    return opts;
  }

  function syncFromPicker() {
    if (!variants) return false;
    var opts = getSelectedOptions();
    var matched = variants.find(function (v) {
      return v.options.every(function (o, i) { return opts[i] === o; });
    });
    if (matched) {
      matched.available ? hideKbite() : showKbite();
      return true;
    }
    return false;
  }

  function syncState() {
    if (!syncFromPageData()) syncFromPicker();
  }

  // Post-fetch sync using the fetched HTML from the eurus event — always accurate
  function syncAfterFetch(e) {
    try {
      var el = e.detail.html.querySelector('[data-selected-variant]');
      if (el) {
        var v = JSON.parse(el.textContent);
        v.available ? hideKbite() : showKbite();
        return;
      }
    } catch (_) {}
    syncState();
  }

  function init() {
    if (initialized) return;

    // Register eurus listeners for all x-atc-button sections in the DOM
    // (prevents accidentally binding only to a quick-view section)
    var atcBtns = document.querySelectorAll('button[id^="x-atc-button-"]');
    if (!atcBtns.length) return;

    // Use first non-quick-view section for variant data; fall back to first found
    var primaryBtn = Array.from(atcBtns).find(function (b) {
      return !b.id.includes('quick-view');
    }) || atcBtns[0];

    var primarySectionId = primaryBtn.id.replace('x-atc-button-', '');

    var variantDataEl = document.getElementById('product-variants-' + primarySectionId);
    if (variantDataEl) {
      try { variants = JSON.parse(variantDataEl.textContent); } catch (_) {}
    }

    atcBtns.forEach(function (btn) {
      var sid = btn.id.replace('x-atc-button-', '');
      document.addEventListener('eurus:product-page-variant-select:updated:' + sid, syncAfterFetch);
    });

    // Suppress flash when theme auto-switches OOS default → first available on load
    if (document.querySelector('script[data-first-available-variant]')) {
      hideKbite();
    } else {
      syncState();
    }

    // Instant pre-fetch feedback on variant change (supports radio buttons and selects)
    if (variants) {
      document.addEventListener('change', function (e) {
        if (!e.isTrusted) return;
        var input = e.target;
        if (!input.closest('.variant-selects')) return;
        if (!input.classList.contains('input-radio') && input.tagName !== 'SELECT') return;

        var opts = getSelectedOptions();
        var parent = input.closest('[data-option-index]');
        if (parent) opts[parseInt(parent.dataset.optionIndex, 10)] = input.value;

        var matched = variants.find(function (v) {
          return v.options.every(function (o, i) { return opts[i] === o; });
        });

        if (matched) matched.available ? hideKbite() : showKbite();
      }, true);
    }

    // Re-apply state whenever Kbite (re-)injects its button after eurus section updates
    var kbiteObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          var isKbite = node.matches && node.matches('button.gw-button-widget-v2');
          var btn = isKbite ? node : (node.querySelector && node.querySelector('button.gw-button-widget-v2'));
          if (btn) {
            applyPending();
            observeButtonStyle(btn);
            return;
          }
        }
      }
    });
    kbiteObserver.observe(document.body, { childList: true, subtree: true });

    var existingBtn = getKbiteBtn();
    if (existingBtn) observeButtonStyle(existingBtn);

    initialized = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
